export function truncate(source, maxLength) {
  return source.length > maxLength
    ? source.slice(0, maxLength - 1) + "…"
    : source;
}

export function parseDom(tagString) {
  const doc = new DOMParser().parseFromString(tagString, "text/xml");
  // doc.firstChild.map((item, index) => item);

  return doc.firstChild;
}

export function htmlDecode(input) {
  var e = document.createElement("div");
  e.innerHTML = input;

  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

export function findObject(arr, type) {
  return arr.find((item) => item._type === type);
}

export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array.slice(0, 10);
}

export function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}
export function generateCDN(url) {
  if (url) {
    return `${url}?auto=format`;
  }
  return "";
}
